import styled from '@emotion/styled';
import { Box, Button, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Product } from 'types/Product';
import shoppingBagImage from 'assets/images/shopping-bag.png';
import moneyBagImage from 'assets/images/money-bag.png';
import woodenBoxImage from 'assets/images/wooden-box.png';

interface CreditCardProps {
  product: Product;
}

const StyledCreditCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  marginBottom: '16px',
  backgroundColor: '#fff',
  border: '1px solid var(--Light-Gray)',
  boxShadow: '0px 1px 2px 0px #0205111A', 
  borderRadius: '32px',
  padding: '32px',
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    gap: '16px',
  },
}));

export const CreditCard: React.FC<CreditCardProps> = ({product}) => {

  const getImageForProduct = () => {
    switch (product.name) {
      case 'Basic':
        return <img src={shoppingBagImage} alt="Shopping Bag" style={{ width: '100px', height: '100px' }} />;
      case 'Standard':
        return <img src={moneyBagImage} alt="Money Bag" style={{ width: '100px', height: '100px' }} />;
      case 'Ultra':
        return <img src={woodenBoxImage} alt="Wooden Box" style={{ width: '100px', height: '100px' }} />
      default:
        return <img src={shoppingBagImage} alt="Shopping Bag" style={{ width: '100px', height: '100px' }} />;
    }
  };

  const handleCheckout = (product: any) => {
    const itemsList = [{
      priceId : product[0].externalPriceId,
      quantity : 1
    }]
    if(window.Paddle){
      window.Paddle.Checkout.open({
        settings: {
          displayMode: "overlay",
          theme: "light",
          locale: "en"
        },
        items: itemsList,
      });
    }
  };

  return (
    <StyledCreditCard sx={{ position: 'relative' }}>
      <Box sx={{ 
        position: 'absolute', 
        top: '-30px', 
        right: '24px',
        zIndex: 1
      }}>
        {getImageForProduct()}
      </Box>

      {/* Title tag */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{
          px: '12px',
          py: '8px',
          backgroundColor: 'background: #FFFFFF59;',
          boxShadow: '12px 12px 32px 0px #FFFFFF40 inset',
          border: '1px solid #0205110D',
          color: 'var(--Interviewer-Black)',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: '600'
        }}>{product.name}</Box>
      </Box>

      <Box>
        <Typography sx={{
          fontSize: '36px',
          fontWeight: '500',
          color: 'var(--Interviewer-Black)'
        }}>
          {/* {product.prices?.[0]?.value} */}
          /
        </Typography>
        <Typography sx={{
          fontSize: '24px',
          fontWeight: '500',
          color: 'var(--Interviewer-Black)',
          pt: '16px'
        }}>${product.prices?.[0]?.value}</Typography>
        <Divider 
          orientation="horizontal" 
          sx={{
            borderColor: 'var(--Interviewer-Near-White)',
            my: '24px'
          }}
        />
        <Typography sx={{color: 'var(--Interviewer-Lighter-Black)', fontSize: '18px', fontWeight: '500'}}>{product.description}</Typography>
      </Box>

      <Button variant='contained' onClick={() => handleCheckout(product.prices)}>Purchase</Button>
    </StyledCreditCard>
  );
};
